import { useCallback } from 'react';

import {
  getExpandedItemsForSubjectFilterSelection,
  useAccordionStorage,
} from '@/module/public/stores/AccordionStore';

import { usePublicCategoryFilter } from './usePublicCategoryFilter';

interface SelectSubjectFilterParams {
  subjectId: string;
  subjectGroupId: string;
  shouldExpandSubjectGroup: boolean;
}

/**
 * 과목 필터 선택과 사이드바 아코디언 상태를 한 번에 동기화한다.
 *
 * 자동완성/외부 진입에서도 사용자가 왼쪽 필터에서 직접 과목을 클릭한 것처럼
 * subject 섹션을 열고, 기존 과목 그룹은 접은 뒤 선택한 그룹만 열어둔다.
 */
export const usePublicSubjectFilterSelection = () => {
  const { handleSelectedSubject } = usePublicCategoryFilter();
  const { expandedItems, handleExpandItems } = useAccordionStorage();

  const selectSubjectFilter = useCallback(
    ({
      subjectId,
      subjectGroupId,
      shouldExpandSubjectGroup,
    }: SelectSubjectFilterParams) => {
      handleSelectedSubject(subjectId);
      handleExpandItems(
        getExpandedItemsForSubjectFilterSelection({
          expandedItems,
          subjectGroupId,
          shouldExpandSubjectGroup,
        }),
      );
    },
    [expandedItems, handleExpandItems, handleSelectedSubject],
  );

  return { selectSubjectFilter };
};
